// The app's reference details (logic/refDetails.ts), shared by every
// pull request the page opens, and dropped when another account signs in.
import { graphqlResult } from '../api/gh';
import { onIdentityChange } from '../api/identity';
import { RefDetails, type RefRequest } from '../logic/refDetails';

let shared = new RefDetails();
onIdentityChange(() => (shared = new RefDetails()));

/** The details held for `key` (see RefDetails.get). */
export const refDetail = (key: string) => shared.get(key);

/**
 * Ask GitHub for the details of `reqs` not held yet. One request covers
 * several repositories, one alias each, so it keeps partial answers: a
 * forbidden or failing repository costs only its own references.
 */
export function loadRefDetails(reqs: readonly RefRequest[]): Promise<void> {
  return shared.load((q, v) => graphqlResult(q, v, { partial: true }), reqs);
}
